<div>
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div>
    <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-alpine"
      rowSelection="multiple"
      rowHeight="48"
      rowMultiSelectWithClick="false"
      suppressRowClickSelection="true"
      suppressDragLeaveHidesColumns="true"
      suppressMenuHide="true"
      enableCellTextSelection="true"
      [icons]="customIcons"
      [columnDefs]="columnDefs"
      [tooltipShowDelay]="500"
      [defaultColDef]="defaultColDef"
      [paginationPageSize]="paginationPageSize"
      [pagination]="true"
      [suppressPaginationPanel]="true"
      [suppressCellSelection]="true"
      [getContextMenuItems]="getContextMenuItems"
      [getMainMenuItems]="getMainMenuItems"
      [suppressScrollOnNewData]="true"
      [rowData]="rowData"
      [domLayout]="domLayout"
      (columnMoved)="onColumnMoved($event)"
      (columnResized)="onColumnResized($event)"
      (columnVisible)="onColumnVisible($event)"
      (rowSelected)="onRowSelected()"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
    <div class="pagination-left">
      <app-pagination
        *ngIf="totalRowsCount > paginationPageSize"
        [totalItems]="totalRowsCount"
        [(currentPage)]="currentPageNumber"
        (change)="onPageChange($event)"
        [pageSize]="paginationPageSize"></app-pagination>
    </div>

    <div class="d-flex align-items-center justify-content-end pagination-right">
      <span class="pagination-count"
        >Showing {{ totalRowsCount > paginationPageSize ? paginationPageSize : totalRowsCount }} of {{ totalRowsCount }} results</span
      >
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === paginationPageSize }">
          <a tabindex="0" (keyup.enter)="changeSize($event, size)" (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #copyModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Test summary</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="d-flex modal-tabs-vertical">
      <ul class="nav flex-column">
        <div tabindex="0" (keyup.enter)="scrollTo(section.id)" *ngFor="let section of testCaseDetails" (click)="scrollTo(section.id)">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === section.id }">
            <span class="nav-text"> {{ section.title }}</span>
          </a>
        </div>
      </ul>

      <div class="tab-content section-parent" id="parentDiv" scrollSpy [spiedTags]="['DIV']" (sectionChange)="onSectionChange($event)">
        <div *ngFor="let section of testCaseDetails" [id]="section.id" class="section-child">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title">{{ section.title }}</li>
            <li *ngFor="let details of section.data">
              <span class="left-col">{{ details[0] }}</span>
              <span class="right-col">{{ details[1] }}</span>
            </li>
            <li *ngIf="section.id === 'smpp'" class="note">
              <span
                >Please note that the logic used to decode the PDU here can’t be guaranteed to be exactly the same logic used by the end device to
                retrieve the individual SMS parameters displayed to the end user, such as Sender ID and Text.
              </span>
            </li>
          </ul>
        </div>
        <!-- This below element is needed to have last section in focus when scrolling ... -->
        <div class="section-empty-child"></div>
      </div>
    </div>
  </div>

  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(true)">Cancel</button>
    </div>
  </div>
</ng-template>

<ng-template #textModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Text delivered</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div>
      <div class="text" [innerHTML]="textModalHtml"></div>
    </div>
  </div>
</ng-template>

<ng-template #smscModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Phone/SMSC</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="two-col-box">
      <ul>
        <li>
          <span class="left-col">Test Number:</span> <span class="right-col">{{ smscData.test.phone }}</span>
        </li>
        <li>
          <span class="left-col">Test Number Country:</span>
          <span class="right-col">{{ smscData.test.country }}</span>
        </li>
        <li>
          <span class="left-col">SMSC:</span> <span class="right-col">{{ smscData.smsc.phone }}</span>
        </li>
        <li *ngIf="smscData.smsc.country">
          <span class="left-col">SMSC Country:</span>
          <span class="right-col" [ngClass]="{ 'text-sucess': !smscData.isError, 'text-error': smscData.isError }">
            {{ smscData.smsc.country }}
          </span>
        </li>
        <li *ngIf="smscData.smsc.provider">
          <span class="left-col">SMSC Provider:</span>
          <span class="right-col" [ngClass]="{ 'text-sucess': !smscData.isError, 'text-error': smscData.isError }">
            {{ smscData.smsc.provider }}
          </span>
        </li>
        <li *ngIf="smscData.smsc.mcc">
          <span class="left-col">SMSC MCC:</span>
          <span class="right-col" [ngClass]="{ 'text-sucess': !smscData.isError, 'text-error': smscData.isError }">
            {{ smscData.smsc.mcc }}
          </span>
        </li>
        <li *ngIf="smscData.smsc.mnc">
          <span class="left-col">SMSC MNC:</span>
          <span class="right-col" [ngClass]="{ 'text-sucess': !smscData.isError, 'text-error': smscData.isError }">
            {{ smscData.smsc.mnc }}
          </span>
        </li>
      </ul>
    </div>
  </div>
  <div class="modal-footer pt-15">
    <span class="footer-note text-error-r2" *ngIf="smscData.isError && smscData.smsc.country">
      The SMSC does not corresponds to the destination country. This might give an indication that SMS has been delivered via non-direct connection.
    </span>
    <span class="footer-note text-sucess" *ngIf="!smscData.isError && smscData.smsc.country">
      The SMSC corresponds to the destination country. This gives an indication that SMS has been delivered via direct connection.
    </span>
  </div>
</ng-template>

<ng-template #commentModalTpl let-dialogRef="dialogRef">
  <div class="modal-header">
    <button aria-label="Close" class="close" type="button" (click)="dialogRef.close(true)">
      <span aria-hidden="true">×</span>
    </button>
    <h3 class="modal-title">Comment</h3>
  </div>
  <div class="modal-body">
    <app-test-result-comment [model]="commentModel" (onAfterSave)="onAfterSaveComment()"></app-test-result-comment>
  </div>
</ng-template>

<ng-template #reimburseModalTpl let-dialogRef="dialogRef">
  <confirm-modal [dialogRef]="dialogRef"></confirm-modal>
</ng-template>

<app-phone-report-widget (phoneReportCreate)="onAfterPhoneReportCreate($event)"></app-phone-report-widget>
